module.exports = "<div class=\"start-tour-bg\">\n  <h4>Would you like to take a quick tour to see rapidInspect’s key features?</h4>\n  <button [routerLink]=\"['/userGuide']\">Yes start the tour</button>\n  <p [routerLink]=\"['/dashboard']\">No. I’ll check back later.</p>\n  <div class=\"logoimg\">\n    <img src=\"../../assets/images/logo-new.svg\">\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/start-tour/start-tour.component.html
// module id = ./src/app/start-tour/start-tour.component.html
// module chunks = main